import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Link,
  Alert,
  useTheme,
} from "@mui/material";
import { AuthContext } from "../../theme/AuthContext";
import { useNavigate } from "react-router-dom";
import { checkEmailExists, checkUserExists, signupUser } from "../../api/authAPI";
import { useSearchParams } from "react-router-dom";

export default function Signup() {
  const theme = useTheme();
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();


  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId");
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    username: "",
    phone: "",
    emailExists: false,
    userExists: false
  });

  const [error, setError] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!form.name || !form.email || !form.username || !form.password || !form.phone) {
      setError("All fields are required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      setError("Please enter a valid email");
      return;
    }

    if (form.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    if (form.phone.length < 10) {
      setError("Phone number must be at least 10 digits");
      return;
    }

    const emailRes = await checkEmailExists(form.email);
    if (emailRes.data.Users.length > 0) {
      setError("Email already exists");
      return;
    }

    const userRes = await checkUserExists(form.username);
    if (userRes.data.Users.length > 0) {
      setError("Username already exists");
      return;
    }

    try {
      const response = await signupUser(
        form.name,
        form.email,
        form.password,
        form.username,
        form.phone,

      );

      console.log("Signup Response:", response);
      // login(); // optional
      navigate(`/confirm-signup?courseId=${courseId || ""}`, {
        state: { username: form.username }
      });

    } catch (error) {
      console.log(error);
      setError("Something went wrong. Try again!");
    }
  };

  return (
    <Box>
      {/* Logo */}
      <Box textAlign="center" mb={3}>
        <Box
          component="img"
          src="/csepathshala.png"
          alt="Topperhub"
          sx={{
            height: 56,
            mb: 1,
            filter:
              theme.palette.mode === "dark"
                ? "brightness(1.1)"
                : "none",
          }}
        />
      </Box>
      <Typography
        variant="h4"
        fontWeight={400}
        textAlign="center"
        mb={3}
        color={theme.palette.text.primary}
      >
        Create Account
      </Typography>

      <Typography
        variant="body1"
        textAlign="center"
        mb={4}
        color={theme.palette.text.secondary}
      >
        Join us and start learning new skills
      </Typography>

      <form onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            label="Full Name"
            fullWidth
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            }}
          />

          <TextField
            label="Email"
            type="email"
            fullWidth
            value={form.email}
            onChange={async (e) => {
              const value = e.target.value;
              setForm({ ...form, email: value });
              setError("")
              console.log("changing email");
              const exists = await checkEmailExists(value);
              console.log(exists.data.Users)
              if (exists.data.Users.length > 0) {
                //show error that user already
                setError("Email already exists")
              }

            }}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            }}
          />

          <TextField
            label="Username"
            type="text"
            fullWidth
            value={form.username}
            onChange={async (e) => {
              const value = e.target.value.trim();

              setForm((prev) => ({ ...prev, username: value }));
              setError("");

              //  Do not hit API for empty or short usernames
              if (!value || value.length < 3) {
                return;
              }

              try {
                const exists = await checkUserExists(value);

                if (exists?.data?.Users?.length > 0) {
                  setError("Username already exists");
                }
              } catch (err) {
                // Ignore 400 errors silently
                if (err.response?.status !== 400) {
                  console.error("Username check failed", err);
                }
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            }}
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            }}
          />

          <TextField
            label="Phone number"
            type="number"
            fullWidth
            value={form.phone}
            onChange={(e) =>
              setForm({ ...form, phone: e.target.value })
            }
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            }}
          />

          <Button
            variant="contained"
            type="submit"
            fullWidth
            sx={{
              borderRadius: "12px",
              paddingY: 1.2,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "16px",
              color: theme.palette.primary.contrastText,
            }}
          >
            Create Account
          </Button>
          {error && <Alert severity="error" sx={{ fontSize: "14px", color: "red", borderRadius: "10px" }}>{error}</Alert>}

          <Typography textAlign="center" mt={1} color={theme.palette.text.secondary}>
            Already have an account?{" "}
            <Link
              sx={{ cursor: "pointer", color: theme.palette.primary.main }}
              onClick={() => navigate(`/login?courseId=${courseId || ""}`)}
              underline="none"
            >
              Login
            </Link>
          </Typography>
        </Stack>
      </form>
    </Box>
  );
}
